let baseUrl = "";

if (process.env.NODE_ENV === "production") {
  //Pre-Producción
  //baseUrl = "https://api.jaquesai.cloudapps.mx/";
  //Produccion
  baseUrl = "https://api-sai.atelierdemargot.com/";
} else {
  baseUrl = "http://localhost:5055/";
}

export const apiHost = baseUrl;
export const factorIva = 0.0;
